import { IDataReaderClient } from "@multiweb/clients/dataReader";
import { INotificationClient } from "@multiweb/clients/notifications";
import { IDataEventsManager } from "OW.Remoting/Remoting/IDataEventsManager";
import { NotificationClient } from "./NotificationClient";

export function defaultFactory(dataReaderClient: IDataReaderClient, dataEventsManager: IDataEventsManager): INotificationClient {
    return new NotificationClient(dataReaderClient, dataEventsManager);
}
